import React from 'react';
import { NavigationBar } from '../components/NavigationBar';
import { HeroSection } from '../components/HeroSection';
import { InterestSection } from '../components/InterestSection';
import { DesireSection } from '../components/DesireSection';
import { ServicesSection } from '../components/ServicesSection';
import { CertificationSection } from '../components/CertificationSection';
import { ReferencesSection } from '../components/ReferencesSection';
import { ActionSection } from '../components/ActionSection';
import { Footer } from '../components/Footer';
export function PlubosHomePage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-253">
      <NavigationBar data-id="element-254" />
      <main data-id="element-255">
        <HeroSection data-id="element-256" />
        <InterestSection data-id="element-257" />
        <DesireSection data-id="element-258" />
        <ServicesSection data-id="element-259" />
        <CertificationSection data-id="element-260" />
        <ReferencesSection data-id="element-261" />
        <ActionSection data-id="element-262" />
      </main>
      <Footer data-id="element-263" />
    </div>;
}